import type {
  RepositoryPickerRepository$data as Repository,
  RepositoryPickerRepositoryIssueTemplates$data as Templates,
} from '@github-ui/item-picker/repository'
import {Box, Label, Link, Text} from '@primer/react'
import {LABELS} from './constants'

type TemplateListPaneFooterProps = {
  repository: Repository
  templates: Templates
}

export const TemplateListPaneFooter = ({repository, templates}: TemplateListPaneFooterProps) => {
  const canIssueType =
    repository.viewerIssueCreationPermissions.typeable && repository.viewerIssueCreationPermissions.triageable

  const hasAnyTemplates = (templates.issueTemplates?.length ?? 0) > 0 || (templates.issueForms?.length ?? 0) > 0
  if (!hasAnyTemplates) {
    return null
  }

  const hyperlinkText = repository.viewerCanPush ? LABELS.editTemplates : LABELS.viewTemplates

  return (
    <Box sx={{pt: 3, alignItems: 'flex-start', textAlign: 'left'}}>
      <Box sx={{display: 'flex'}}>
        {canIssueType && (
          <Box sx={{display: 'flex'}}>
            <Label variant="success" sx={{mr: 2}}>
              Beta
            </Label>
            <Text sx={{mr: 2}}>🎉 You can now add issue types to your forms and templates!</Text>
          </Box>
        )}
        <Link href={templates.templateTreeUrl}>{hyperlinkText}</Link>
      </Box>
    </Box>
  )
}

try{ TemplateListPaneFooter.displayName ||= 'TemplateListPaneFooter' } catch {}